import { TrendMapper } from '../mapper/TrendMapper';

export const trendMapper = new TrendMapper();
